import kpi from './kpi'
import kpiRecord from './kpiRecord'
import kpiResult from './kpiResult'

const KpiServer = {
    kpi,
    kpiRecord,
    kpiResult,
};

export default KpiServer;
